import { createApp } from 'vue'
import App from './App.vue'

// Style imports
import './styles/reset.css'
import './styles/resume.css'

createApp(App).mount('#app')
